/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React from "react"
import { Button, shadows } from "@carrotfertility/carotene"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"

const StyledButton = styled(Button)`
  box-shadow: ${shadows.light};
  position: absolute;
  top: 0;
  left: 50%;
  margin-top: 24px;
  transform: translate(-50%, 0);
`

export function SearchThisLocationButton({ onClick }: { onClick: () => void }): JSX.Element {
  return (
    <StyledButton id="provider-finder-search-this-location-button" variant="secondary" onClick={onClick}>
      <FormattedMessage defaultMessage="Search this location" />
    </StyledButton>
  )
}
